import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';

interface NavbarProps {
  isInline?: boolean;
}

export default function Navbar({ isInline = false }: NavbarProps) {
  const [scrolled, setScrolled] = useState(false);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (isInline) return;
    const handleScroll = () => {
      const y = window.scrollY;
      setScrolled(y > 60);
      setVisible(y > 10);
    };
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, [isInline]);

  if (isInline) {
    return (
      <header className="relative bg-primary-500 shadow-[0_2px_0_rgba(255,255,255,0.2),0_4px_16px_rgba(255,255,255,0.08)]">
        <div className="absolute bottom-0 left-0 right-0 h-[1px] bg-white/20" />
        <div className="flex items-center justify-between h-[64px] px-6 md:px-10 max-w-[1440px] mx-auto">
          <Link to="/" className="flex items-center gap-3 group shrink-0">
            <div className="w-auto h-9 md:h-10 flex items-center justify-center shrink-0">
              <img
                src="https://storage.readdy-site.link/project_files/9e4a4ca5-4366-4703-9301-bafa1f14e1f9/61b8d58b-ccfc-4ad3-8bde-a9818c85bf50_compressed_4eb3455d6c1177e0e2b6c9460a34b69a.webp"
                alt="华东交通大学校徽"
                className="h-full w-auto object-contain"
              />
            </div>
          </Link>
          <Link
            to="/"
            className="text-sm font-medium tracking-wide whitespace-nowrap transition-all duration-300 px-5 py-2 rounded-md text-white border border-white/25 hover:bg-white/10 hover:border-white/45"
          >
            返回首页
          </Link>
        </div>
      </header>
    );
  }

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 h-[52px] ${
        visible ? 'translate-y-0 opacity-100' : '-translate-y-full opacity-0'
      } ${
        scrolled
          ? 'bg-primary-500/95 backdrop-blur-md shadow-[0_2px_16px_rgba(139,1,1,0.25)]'
          : 'bg-primary-500 shadow-[0_2px_0_rgba(255,255,255,0.2),0_4px_16px_rgba(255,255,255,0.08)]'
      }`}
    >
      <div className="absolute bottom-0 left-0 right-0 h-[1px] bg-white/20" />

      <div className="flex items-center justify-between h-full px-4 sm:px-6 md:px-10 max-w-[1440px] mx-auto">
        <Link
          to="/"
          className="flex items-center gap-2 md:gap-3 group shrink-0 min-w-0"
        >
          <div className="w-[40px] h-[40px] sm:w-[52px] sm:h-[52px] md:w-[100px] md:h-[100px] lg:w-[180px] lg:h-[180px] flex items-center justify-center shrink-0">
            <img
              src="https://storage.readdy-site.link/project_files/9e4a4ca5-4366-4703-9301-bafa1f14e1f9/61b8d58b-ccfc-4ad3-8bde-a9818c85bf50_compressed_4eb3455d6c1177e0e2b6c9460a34b69a.webp"
              alt="华东交通大学校徽"
              className="w-full h-full object-contain"
            />
          </div>
          <div className="flex items-center gap-1.5 md:gap-2.5">
            <span className="hidden sm:block w-[2px] h-6 md:h-8 bg-white/25" />
            <span className="text-xs sm:text-sm md:text-base font-semibold text-white/90 max-w-[160px] sm:max-w-[280px] md:max-w-[400px] lg:max-w-[600px] leading-snug line-clamp-2 md:line-clamp-none">
              学科赋能、需求牵引、交叉融合 轨道交通特色土建类一流专业建设探索与实践
            </span>
          </div>
        </Link>

        <Link
          to="/"
          className="text-xs sm:text-sm font-medium tracking-wide whitespace-nowrap transition-all duration-300 px-3 sm:px-5 py-1.5 sm:py-2 rounded-md text-white border border-white/25 hover:bg-white/10 hover:border-white/45 shrink-0 ml-2"
        >
          返回首页
        </Link>
      </div>
    </header>
  );
}